<template>
  <div
    class="status-alert"
    :class="`status-alert--${status}`"
    role="status"
  >
    <span class="status-alert__icon">
      <FontAwesomeIcon
        :icon="['fas', icon]"
        fixed-width
      />
    </span>
    <div class="status-alert__content">
      <strong>{{ title }}</strong>
      <small v-if="message">{{ message }}</small>
    </div>
    <el-button
      v-if="actionLabel"
      size="mini"
      class="status-alert__action"
      @click="$emit('action')"
    >
      {{ actionLabel }}
    </el-button>
  </div>
</template>

<script>
const STATUSES = ['info', 'success', 'warning', 'danger']
const STATUS_ICONS = {
  info: 'info-circle',
  success: 'check-circle',
  warning: 'exclamation-circle',
  danger: 'exclamation-triangle'
}

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'info',
      validator: value => STATUSES.includes(value)
    },
    actionLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    icon () {
      return STATUS_ICONS[this.status]
    }
  }
}
</script>

<style lang="scss" scoped>
.status-alert {
  align-items: center;
  background: #eef3fa;
  border: 1px solid #b9c9df;
  border-radius: 4px;
  color: #26364d;
  display: flex;
  min-height: 70px;
  padding: 14px 16px;

  &--success {
    background: #edf6f2;
    border-color: #acd1c1;
  }

  &--warning {
    background: #f4f0e5;
    border-color: #d8c28b;
  }

  &--danger {
    background: #faeeee;
    border-color: #e0aaaa;
  }
}

.status-alert__icon {
  color: #315bac;
  font-size: 18px;
  margin-right: 12px;
}

.status-alert--success .status-alert__icon {
  color: #2f8f6b;
}

.status-alert--warning .status-alert__icon {
  color: #a66a00;
}

.status-alert--danger .status-alert__icon {
  color: #b43f3f;
}

.status-alert__content {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;

  strong {
    font-size: 13px;
  }

  small {
    margin-top: 5px;
  }
}

.status-alert__action {
  margin-left: 16px;
}

@media (max-width: 600px) {
  .status-alert {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .status-alert__action {
    margin: 12px 0 0 30px;
  }
}
</style>
